import { useEffect, useMemo, useState } from "react";
import { api, API } from "@/lib/api";
import { toast } from "sonner";
import { Search, Download, Trash2, Edit2 } from "lucide-react";

export default function AdminParticipants() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [eventFilter, setEventFilter] = useState("");
  const [events, setEvents] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/participants").then((r) => setList(r.data));
  useEffect(() => { load(); api.get("/events").then((r) => setEvents(r.data)); }, []);

  const filtered = useMemo(() => {
    return list.filter((p) =>
      (!eventFilter || p.event_id === eventFilter) &&
      (!q || `${p.full_name} ${p.whatsapp} ${p.city} ${p.church} ${p.registration_id}`.toLowerCase().includes(q.toLowerCase()))
    );
  }, [list, q, eventFilter]);

  const updateStatus = async (p, status) => {
    await api.put(`/participants/${p.id}`, { status });
    toast.success("Status atualizado");
    load();
  };
  const del = async (id) => {
    if (!confirm("Excluir inscrição?")) return;
    await api.delete(`/participants/${id}`);
    toast.success("Excluído");
    load();
  };
  const exportCsv = async () => {
    const token = localStorage.getItem("ci_token");
    const url = `${API}/participants/export${eventFilter ? `?event_id=${eventFilter}` : ""}`;
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "participantes.csv";
    a.click();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="label">Participantes</div>
          <h1 className="font-display text-3xl sm:text-4xl font-black mt-2">Inscrições</h1>
        </div>
        <button data-testid="admin-export-csv" onClick={exportCsv} className="btn-primary text-sm"><Download size={16}/> Exportar CSV</button>
      </div>

      <div className="flex gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <input data-testid="admin-search-participants" placeholder="Buscar por nome, WhatsApp, cidade..." value={q} onChange={(e)=>setQ(e.target.value)} className="ci-input pl-10" />
        </div>
        <select data-testid="admin-filter-event" value={eventFilter} onChange={(e)=>setEventFilter(e.target.value)} className="ci-input min-w-[180px] flex-none">
          <option value="">Todos eventos</option>
          {events.map((e)=> <option key={e.id} value={e.id}>#{e.edition_number} — {e.name}</option>)}
        </select>
      </div>

      <div className="ci-card p-0 overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="text-xs text-slate-500 text-left border-b border-blue-500/10">
              <th className="p-4">ID</th><th className="p-4">Nome</th><th className="p-4">WhatsApp</th><th className="p-4">Idade</th><th className="p-4">Igreja</th><th className="p-4">Evento</th><th className="p-4">Participação</th><th className="p-4">Status</th><th className="p-4">Ações</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr key={p.id} className="border-t border-blue-500/10 hover:bg-blue-500/5">
                <td className="p-4 font-mono text-xs text-blue-300">{p.registration_id}</td>
                <td className="p-4"><div className="font-medium">{p.full_name}</div>{p.nickname && <div className="text-xs text-slate-500">"{p.nickname}"</div>}</td>
                <td className="p-4 text-slate-300">{p.whatsapp}</td>
                <td className="p-4 text-slate-300">{p.age}</td>
                <td className="p-4 text-slate-400 text-xs">{p.church || "—"}<br/>{p.city}</td>
                <td className="p-4 text-slate-400 text-xs">#{p.event_edition}</td>
                <td className="p-4">
                  <span className={`text-[10px] font-bold px-2 py-1 rounded-full border ${p.both_days ? "bg-blue-500/10 text-blue-300 border-blue-500/30" : "bg-amber-500/10 text-amber-300 border-amber-500/30"}`}>
                    {p.both_days ? "DOIS DIAS" : "1º DIA"}
                  </span>
                </td>
                <td className="p-4">
                  <select value={p.status} onChange={(e)=>updateStatus(p, e.target.value)} className="bg-slate-900 border border-blue-500/20 rounded-lg px-2 py-1 text-xs">
                    <option value="confirmed">Confirmado</option>
                    <option value="pending">Pendente</option>
                    <option value="cancelled">Cancelado</option>
                  </select>
                </td>
                <td className="p-4"><button data-testid={`admin-participant-delete-${p.id}`} onClick={() => del(p.id)} className="text-slate-400 hover:text-red-400"><Trash2 size={14}/></button></td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={9} className="p-8 text-center text-slate-500">Nenhuma inscrição.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
